import { render, staticRenderFns } from "./EventReminderSettingOption.vue?vue&type=template&id=66bca3b8"
import script from "./EventReminderSettingOption.vue?vue&type=script&lang=js"
export * from "./EventReminderSettingOption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports